import {formatPrice} from '../common';
import moment from "moment";

const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
moment.locale('ru');

export default class UserLocationPopup {
  constructor() {
    this.selected = false;
    this.$locationAddress = $("#location-address");

    this.$locationAddress.on('input', e => {
      this.selected = false;
    });

    this.$locationAddress.blur(e => {
      setTimeout(() => {
        if (!this.selected) {
          $("#location-address").val('');
        }
      }, 200)
    });

    this.$locationAddress.keypress(e => {
      if (e.keyCode == 13) {
        $('#location-address').trigger("blur");
      }
    });

    this.$locationAddress.autocomplete({
      source: "/ajax/autocompleteAddress2.php",
      minLength: 1,
      appendTo: '#address-container',
      focus: (event, ui) => {
        this.selected = false;
      },
      select: (event, ui) => {
        this.selected = true;
        if (ui.item.value.length) {
          $("#location-address").val(ui.item.value);
        }
      },
      close: (event, ui) => {
      }
    });

    $('.js-select-location').on('click', e => {
      let $error = $('.form-group-help'),
        street = this.$locationAddress.val(),
        house = $('#location-house').val(),
        housing = $('#location-housing').val();
      e.preventDefault();
      e.stopPropagation();
      if (street && house) {
        $error.html('');
        window.stopListPreloaded = undefined;
        this.checkDeliveryLocation(street, house, housing);
      } else {
        $error.html('Укажите улицу и номер дома');
      }
    });
  }

  show() {
    let $locationModal = $(document).find('#locationModal');
    if ($locationModal.length) {
      $locationModal.foundation();
      $locationModal.foundation('open');
    }
    this.setPopupWasOpened();
  }

  hide() {
    let $locationModal = $(document).find('#locationModal');
    $locationModal.foundation('close');
  }

  showOrderPricePopup() {
    $('#orderDeliveryPricePopup').modal({
      backdrop: 'static',
      keyboard: false
    });
  }

  setPopupWasOpened() {
    $.ajax({
      method: 'POST',
      url: '/ajax/user-location.php',
      data: {action: 'hidePopup'},
      cache: false,
      dataType: 'json',
      success: result => {
      }
    });
  }

  checkDeliveryLocation(address, house, housing) {

    $.ajax({
      url: '/ajax/user-location.php',
      dataType: 'json',
      data: {
        action: 'checkLocation',
        allowFlip:true,
        address: address,
        house: house,
        housing: housing
      },
      success: res => {
        let deliveryInfo = res.DELIVERY_INFO;

        this.hide();
        if (res && res.PRICES && Object.keys(res.PRICES).length > 0) {

          try{
            let superStupidWay = $('.js-catalog-menu-day.day_active');
            superStupidWay[0].click();
          }catch (e){
            console.error(e);
          }
          let headerAdressString = $('[data-entity="popup-address-value"]');

          let headerMinPriceToday = res.PRICES.todayPrice;

          let todayDateKey = moment().format(MOMENT_DATE_FORMAT);

          if(headerMinPriceToday > 1){
            this.unblockCalendarDate(todayDateKey);
          }

          let headerMinPriceTomorrow = res.PRICES.tomorrowPrice;
          let addressString = res.ADDRESS.street;
          window.changeSwitchBlocks(res.PRICES.todayPrice);


          if (res.ADDRESS.house) {
            addressString += (', д. ' + res.ADDRESS.house);
          }
          if (res.ADDRESS.housing) {
            addressString += (', к. ' + res.ADDRESS.housing);
          }
          if (headerAdressString.length) {
            headerAdressString.text(addressString);
            window.printMobileAdrress(addressString);
          }

          if (headerMinPriceToday && $('[data-entity="popup-address-price-today"]').length) {
            $('[data-entity="popup-address-price-today"]').text(headerMinPriceToday)
          }
          if (headerMinPriceToday && $('[data-entity="popup-address-price-tomorrow"]').length) {
            $('[data-entity="popup-address-price-tomorrow"]').text(headerMinPriceTomorrow)
          }
          $('[data-entity="popup-address-price-wrapper"]').fadeIn(200);
          this.showDeliveryInfoByTodayPricePopup(parseFloat(res.PRICES.todayPrice), parseFloat(res.PRICES.tomorrowPrice), deliveryInfo);
        } else {
          this.showDeliveryInfoByTodayPricePopup(false, false);
        }


        this.showOrderPricePopup();
      }
    });
  }


  unblockCalendarDate(date) {
    let calendarWrapper = $('[data-entity="catalog-calendar-wrapper"]');
    let calendarDate = $(calendarWrapper.find('[data-date="' + date + '" ]')[0]);
    if (!calendarDate.hasClass('js-catalog-menu-day')) {
      calendarDate.removeClass('day__blocked');
      calendarDate.addClass('js-catalog-menu-day')
    }
  }

  showDeliveryInfoByTodayPricePopup(todayPrice, tomorrowPrice, deliveryInfo = false,deliveryLocation = false) {
    const $popupInfoBlock = $(document).find('#orderDeliveryPricePopup .order-delivery-info-popup');

    let $xModalBodyNew = $(document).find('.x-modal-body-new'),
      html = "";

    if (todayPrice === false && tomorrowPrice === false) {
      $popupInfoBlock.addClass('map-alert-error');
      $popupInfoBlock.html('<p>К сожалению, для указанного адреса мы не можем доставить заказ.</p>');
    } else {
      let todayMinPrice,
        tomorrowMinPrice,
        tomorrowMinPriceFormat;

      todayMinPrice = todayPrice > 1 ? formatPrice(todayPrice) : '<div class="text-gray">не возможна</div>';
      tomorrowMinPrice = parseInt(tomorrowPrice);
      tomorrowMinPriceFormat = formatPrice(tomorrowMinPrice);

      $popupInfoBlock.addClass('map-alert-success');

      let arPrice = [],
        minPrice = 0;

      if ($xModalBodyNew.length) {
        if (deliveryInfo !== false) {
          if (deliveryInfo.DELIVERY_TODAY_BEFORE_INTERVAL_1 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TODAY_BEFORE_INTERVAL_1);
          }
          if (deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_1 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_1);
          }
          if (deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_2 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TODAY_FROM_INTERVAL_2);
          }

          if (deliveryInfo.DELIVERY_TOMORROW_BEFORE_INTERVAL_1 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TOMORROW_BEFORE_INTERVAL_1);
          }
          if (deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_1 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_1);
          }
          if (deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_2 > 1) {
            arPrice.push(deliveryInfo.DELIVERY_TOMORROW_FROM_INTERVAL_2);
          }

          minPrice = Math.min.apply(null, arPrice);
        }
      }

      if (tomorrowMinPrice === 899) {
        html = '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
          '<div class="min-sum">' + todayMinPrice + '</div>' +
          '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
          '<div class="min-sum"><span class="old-price">' + formatPrice(1200) + '</span> ' + tomorrowMinPriceFormat + '<sup>*</sup></div>' +
          '<div class="notion">* до 10.06.2020</div>';

        if ($xModalBodyNew.length) {
          html = '<p>Минимальная сумма для бесплатной доставки на <span class="text-important">сегодня</span>:</p>\n' +
            '<div class="min-sum">' + todayMinPrice + '</div>' +
            '<p>Минимальная сумма для бесплатной доставки на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
            '<div class="min-sum"><span class="old-price">' + formatPrice(1200) + '</span> ' + tomorrowMinPriceFormat + '<sup>*</sup></div>' +
            '<div class="notion">* до 10.06.2020</div>';

          if (parseInt(minPrice) > 0) {
            html = html +
              '<p>Стоимость <span class="text-important">платной доставки</span>:</p>\n' +
              '<div class="min-sum">от ' + formatPrice(minPrice) + '</div>';
          }
        }
        $popupInfoBlock.html(html);
      } else {
        html = '<p>Минимальный заказ при доставке на <span class="text-important">сегодня</span>:</p>\n' +
          '<div class="min-sum">' + todayMinPrice + '</div>' +
          '<p>Минимальный заказ на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
          '<div class="min-sum">' + tomorrowMinPriceFormat + '</div>';

        if ($xModalBodyNew.length) {
          html = '<p>Минимальная сумма для бесплатной доставки на <span class="text-important">сегодня</span>:</p>\n' +
            '<div class="min-sum">' + todayMinPrice + '</div>' +
            '<p>Минимальная сумма для бесплатной доставки на <span class="text-important">завтра и следующие дни</span>:</p>\n' +
            '<div class="min-sum">' + tomorrowMinPriceFormat + '</div>';

          if (parseInt(minPrice) > 0) {
            html = html +
              '<p>Стоимость <span class="text-important">платной доставки</span>:</p>\n' +
              '<div class="min-sum">от ' + formatPrice(minPrice) + '</div>';
          }
        }

        $popupInfoBlock.html(html);
      }
    }
  }
}
